import Labels from "./labels";

export default Labels;
